<template>
    <div
        v-if="caption && caption.toLowerCase() !== 'ferrule'"
        class="text-lg mb-4"
    >
        {{caption}}
    </div>

    <div
        v-if="!nameHidden"
        class="mb-[16px] flex justify-between items-center"
    >
        <div class="flex justify-between items-center w-full font-oceanside">
            <p v-html="placementLabel" class="font-semibold text-[16px] leading-[17px]" />
            <p v-html="selectedValue" class="text-[16px] leading-[17px]" />
        </div>
    </div>
</template>

<script>
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        props: {
            placement: Object,
            index: Number,
        },

        computed: {
            viewController() {
                return this.customizerStore.viewController;
            },

            caption() {
                return this.placement.custom?.['v-caption'];
            },

            learnMoreVimeo() {
                return this.placement.custom?.['v-learn-more-vimeo'];
            },

            learnMore() {
                return this.placement.custom?.['v-learn-more'];
            },

            nameHidden() {
                return this.placement.custom?.['v-name-hidden'] === 'yes';
            },

            placementLabel() {
                if (!this.placement?.name) {
                    return '';
                }

                const name = this.placement.name.trim();
                const price = this.pricedOncePrice ? ` <span class="ml-1 font-semibold">${this.pricedOncePrice}</span>` : '';

                return `${name}${price}`;
            },

            selectedValue() {
                const { selectedValue } = this.placement;
                const selectedComponent = this.placement.components.find((x) => x.code === selectedValue);

                if (!selectedComponent) {
                    return '';
                }

                return selectedComponent.description[0].name;
            },

            pricedOnce() {
                if (this.placement?.components) {
                    // eslint-disable-next-line no-restricted-syntax
                    for (const option of this.placement.components) {
                        if (option.priceOnce) {
                            return option;
                        }
                    }
                }

                return null;
            },

            pricedOncePrice() {
                const once = this.pricedOnce;

                if (once) {
                    return this.customizerStore.getOptionPrice(this.viewController, once);
                }

                return null;
            },
        },
    };
</script>
